
import { defineComponent, ref, onMounted } from 'vue'

import { useI18n } from "vue-i18n/index";
import srvStudent from "@/core/services/StudentsService"
import { errManager } from "@/core/config/Tools";

//components
import AddEdit from "./AddEdit.vue"

export default defineComponent({
    name: "Students",
    components: { AddEdit },
    setup() {
        const { t } = useI18n()
        const loading = ref(false)
        const listStudent = ref([])

        const getDataList = async () => {
            loading.value = true
            listStudent.value = []
            await srvStudent.getData({})
            .then( (res) => {
                listStudent.value = res.data
                loading.value = false
            }).catch( ({response}) => {
                loading.value = false
                errManager(response)
            })
        }

        onMounted(()=>{
            getDataList()
        })

        return {
            t,
            loading,
            listStudent,
            //methods
            getDataList
        }
        
    },
})
